import { format } from 'date-fns';
import { convertToDate } from 'utils/dates';

export const TIME_FORMAT_DATE = 'yyyy-MM-dd';

export enum PERMISSIONS {
  EDIT_SETTINGS = 'isAllowToEditSetting',
  EDIT_LABELS = 'isAllowToEditLabels',
  EDIT_PROFILE = 'isAllowToEditProfile',
  EDIT_CRM_USERS = 'isAllowToEditCRMUsers',
  EDIT_PERMISSIONS = 'isAllowToEditPermissions',
  VIEW_LOG = 'isAllowToViewLog',
  VIEW_SENSITIVE = 'isAllowToViewSensitiveInformation',
  RESET_SENSITIVE = 'isAllowToResetSensitiveInformation',
}

export const EDITOR_CONFIG_LIGHT = {
  buttons: 'bold,|,ul,ol,|,align,|,fontsize,link,|,undo,redo',
};

const excelGridColumns = [
  {
    title: 'date',
    field: 'startDate',
    valueTemplate: (row: any) => {
      return format(convertToDate(row.startDate), TIME_FORMAT_DATE)
    }
  },
  {
    title: 'name',
    field: 'fullName',
  },
  {
    title: 'position',
    field: 'position',
  },
  {
    title: 'company-name',
    field: 'companyName',
  },
  {
    title: 'mobile-phone',
    field: 'mobilePhone',
  },
  {
    title: 'email',
    field: 'email',
  },
  {
    title: 'user-expert-status',
    field: 'userExpertStatus.title as userExpertStatusTitle',
  },
  {
    title: 'industry',
    field: 'industry.title as industryTitle',
  },
  {
    title: 'city',
    field: 'city.title as cityTitle',
  },
  {
    title: 'is-allow-sms',
    field: 'isAllowSMS',
  }
];

export const createExcelGridColumns = (prefix?: string) => {
  return excelGridColumns.map((item) => {
    return { ...item, field: [prefix, item.field].filter((v) => v).join('.') };
  });
};
